import { render } from "./SmIconViewComponent.vue?vue&type=template&id=9a67bdee"
import script from "./SmIconViewComponent.vue?vue&type=script&lang=js"
export * from "./SmIconViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmIconViewComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a67bdee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a67bdee', __exports__)) {
    api.reload('9a67bdee', __exports__)
  }
  
  module.hot.accept("./SmIconViewComponent.vue?vue&type=template&id=9a67bdee", () => {
    api.rerender('9a67bdee', render)
  })

}


export default __exports__